import { styled, Flex, LinkV1 } from '@withjoy/joykit';

export const StyledFlex = styled(Flex)<{ isMobile: boolean }>`
  ${props =>
    props.isMobile
      ? `
  flex-direction: column;
  > div {
    margin-bottom: 24px;
  }
`
      : undefined}
`;

export const StyledButtonFlex = styled(Flex)<{ isMobile: boolean }>`
  ${props =>
    props.isMobile
      ? `
  flex-direction: column-reverse;
  width: 100%;
  > * {
    margin-bottom: 24px;
  }
`
      : undefined}
`;

export const StyledLink = styled(LinkV1)`
  min-height: 48px;
  min-width: 132px;
  font-weight: 600;
`;

export const StyledText = styled.span`
  font-weight: 600;
`;
